/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import './RoomLeaderboard.css';
import Loading from './Loading';

import {
  getRankEscape,
} from '../../actions';


class RoomLeaderboard extends Component {

  state = {};

  componentDidMount() {
    let params = {
      room: this.props.roomId,
      escape: this.props.escapeId,
    }

    this.setState({ loading: true });
    this.props.getRankEscape(null, { local: true }, params)
      .then(resp => {
        this.setState({ loading: false, rank: resp.obj });
      });
  }

  renderRank() {
    let rank = this.state.rank;
    if (!rank) return;

    let r = 1;
    let nodes = rank.escapes.map(escape => {
      let prettyDate;
      if (escape.date) {
        prettyDate = <div className="date">{moment(escape.date, 'YYYY-MM-DD').format('MMM D, YYYY')}</div>;
      }
      return (
        <div className={cx('ranked-escape', { highlight: escape.id == this.props.escapeId })}>
          <div className="num">#{r++}</div>
          <div className="name">
            <div>{escape.displayName}</div>
            {prettyDate}
          </div>
          <div className="time">{escape.prettyTime}</div>
        </div>
      );
    });

    return (
      <div className="leaderboard">
        <div className="room-info">
          <div className="room-name">{rank.room.name}</div>
          <div className="sub">EscapeSpy Leaderboard</div>
        </div>
        <div className="ranked">
          {nodes}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="RoomLeaderboard">
        {this.state.loading && <Loading />}
        {!this.state.loading && this.renderRank()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getRankEscape,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoomLeaderboard);



/** WEBPACK FOOTER **
 ** ./src/components/partials/RoomLeaderboard.js
 **/